<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  mounted () { 
    setTimeout(() => {
      this.$nextTick(() => {
        const appElement = document.getElementById('app')
        if (this.$route.path !== '/inviteIndex') { 
          appElement.style.minWidth = '1270px'
          appElement.style.overflowX = 'auto'
        } else {
          appElement.style.minWidth = ''
          appElement.style.overflowX = ''
        }
      })
    }, 500)
  }
};
</script>
<style>
* {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0;
    margin: 0;
    border: 0;
    outline: none;
}
</style>